export default {
      id: "cabinet-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#cabinet",
      toString: function () {
        return this.url;
      }
    }